import { const_var, params } from "../../../redux/reducers/reducer";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer";
import * as utils from "../../../redux/reducers/utils";
import utilityStorageOptionsHelpers from "../../building_pricing/utility_pricing/utilityStorageOptions.helpers";

export const addBuildingUtility = (state, action) => {
	let UpdateStorageAction = "";

	let rightWall, leftWall, backWall;
	state.params.cB_addStorage_check_right ? (rightWall = true) : (rightWall = false);
	state.params.cB_addStorage_check_left ? (leftWall = true) : (leftWall = false);
	state.params.p_u_c ? (backWall = true) : (backWall = false);

	if (action.storage === "back") {
		state.params.p_u_c = !state.params.p_u_c;
		if (state.params.p_u_c) state.params.prev_p_b_w = state.params.p_b_w;
		if (params.p_u_c == true) {
			params.cB_addStorage_check_right = false;
			params.cB_addStorage_check_left = false;
			params.nostorage = false;
			params.cB_addStorage_check_both_with_back = false;
			params.cB_addStorage_check_both = false;
		}
		params.endStoragePositionZ = 0;
		state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		params.p_b_w = "Open";
		state.params.p_u_f_w = "Close";
		if (rightWall == true && state.isFullyEnclosedChecked != true) {
			params.p_r_w = "Open";
		}
		if (leftWall == true && state.isFullyEnclosedChecked != true) {
			params.p_l_w = "Open";
		}
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		cuBuilding.BuildingUpdate(false, "utilitywall");

		if (params.p_l_w != "Close") {
			if (params.p_r_w != "Close") {
			}
		} else if (params.p_b_w != "Close") {
		} else if (params.p_l_w != "Close" && params.p_b_w != "Close") {
		} else {
		}

		utils.wallSelectionChangesForLNTBuilding(state, "back", true);
		UpdateStorageAction = action.event + action.storage + params.p_u_c;
	} else if (action.storage === "left") {
		if (
			(state.params.cB_addStorage_check_right || state.params.p_u_c) &&
			const_var.insulationPriceJson?.insulation_wall != undefined &&
			const_var.insulationPriceJson.insulation_wall["storage_left"] != undefined &&
			const_var.insulationPriceJson.insulation_wall["storage_left"] == true
		) {
			delete const_var.insulationPriceJson.insulation_wall["storage_left"];
		}
		state.params.cB_addStorage_check_left = !state.params.cB_addStorage_check_left;
		state.params.cB_addStorage_check_right = false;
		if (state.params.cB_addStorage_check_left == false) {
			state.params.cB_addStorage_check_left_utility = false;
		}
		if (params.cB_addStorage_check_left == true) {
			params.p_u_c = false;
			params.cB_addStorage_check_right = false;
			params.nostorage = false;
			params.cB_addStorage_check_both_with_back = false;
			params.cB_addStorage_check_both = false;
			params.p_c_p_l = false;
		}
		state.params.cB_addStorage_left = state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s];
		params.p_l_w = state.params.cB_addStorage_check_left == false ? (params.add_left_lean == true ? 1 : "Open") : params.p_l_w;

		if (params.p_f_w == "Half End" || params.p_f_w == "Half Dutch End") params.p_f_w = "Open";
		if (params.p_b_w == "Half End" || params.p_b_w == "Half Dutch End") params.p_b_w = "Open";

		if (state.isFullyEnclosedChecked != true) {
			params.p_r_w = params.p_r_w;
		}
		if (state.isFullyEnclosedChecked == true) {
			params.p_b_w = params.p_l_w = params.p_r_w = "Close";
		}
		if (rightWall == true && state.isFullyEnclosedChecked != true) {
			params.p_r_w = "Open";
			params.p_c_p_r = false;
		}
		if (backWall == true && state.isFullyEnclosedChecked != true) {
			params.p_b_w = "Open";
		}
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		params.cB_addStorage_left = Math.round(params.p_w / 2);
		cuBuilding.BuildingUpdate(false, "utilitywallLeft");

		utils.wallSelectionChangesForLNTBuilding(state, "left", true);
		UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_left;
	} else if (action.storage === "right") {
		if (
			(state.params.cB_addStorage_check_left || state.params.p_u_c) &&
			const_var.insulationPriceJson?.insulation_wall != undefined &&
			const_var.insulationPriceJson.insulation_wall["storage_right"] != undefined &&
			const_var.insulationPriceJson.insulation_wall["storage_right"] == true
		) {
			delete const_var.insulationPriceJson.insulation_wall["storage_right"];
		}
		state.params.cB_addStorage_check_right = !state.params.cB_addStorage_check_right;
		state.params.cB_addStorage_check_left = false;
		if (state.params.cB_addStorage_check_right == false) {
			state.params.cB_addStorage_check_right_utility = false;
		}
		params.p_r_w = state.params.cB_addStorage_check_right == false ? (params.add_right_lean == true ? 1 : "Open") : params.p_r_w;
		if (params.p_f_w == "Half End" || params.p_f_w == "Half Dutch End") params.p_f_w = "Open";
		if (params.p_b_w == "Half End" || params.p_b_w == "Half Dutch End") params.p_b_w = "Open";

		state.params.cB_addStorage_right = state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s];
		if (params.cB_addStorage_check_right == true) {
			params.p_u_c = false;
			params.cB_addStorage_check_left = false;

			params.nostorage = false;
			params.cB_addStorage_check_both_with_back = false;
			params.cB_addStorage_check_both = false;
			params.p_c_p_r = false;
		}

		if (state.isFullyEnclosedChecked != true) {
			params.p_l_w = params.p_l_w; //"Open"
		}
		if (state.isFullyEnclosedChecked == true) {
			params.p_b_w = params.p_l_w = params.p_r_w = "Close";
		}

		if (leftWall == true && state.isFullyEnclosedChecked != true) {
			params.p_l_w = "Open";
			params.p_c_p_l = false;
		}
		if (backWall == true && state.isFullyEnclosedChecked != true) {
			params.p_b_w = "Open";
		}

		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;

		params.cB_addStorage_right = Math.round(params.p_w / 2);

		cuBuilding.BuildingUpdate(false, "utilitywallRight");
		utils.wallSelectionChangesForLNTBuilding(state, "right", true);
		UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right;
	} else if (action.storage === "both") {
		params.cB_addStorage_check_both = !params.cB_addStorage_check_both;
		state.params.cB_addStorage_check_right = params.cB_addStorage_check_both;
		state.params.cB_addStorage_check_left = params.cB_addStorage_check_both;

		params.nostorage = false;
		params.cB_addStorage_check_both_with_back = false;

		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;

		params.cB_addStorage_right = Math.round(params.p_w / 2 - 2.5);
		params.cB_addStorage_left = Math.round(params.p_w / 2 - 2.5);

		cuBuilding.BuildingUpdate(false, "utilitywallRight");
		cuBuilding.BuildingUpdate(false, "utilitywallLeft");
		if (params.p_l_w != "Close") {
		} else {
		}
		if (params.p_r_w != "Close") {
		} else {
		}
		UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right + params.cB_addStorage_check_left;
	} else if (action.storage == "bothside_with_back") {
		params.cB_addStorage_check_both_with_back = !params.cB_addStorage_check_both_with_back;
		params.p_u_c = params.cB_addStorage_check_both_with_back;
		state.params.cB_addStorage_check_right = params.cB_addStorage_check_both_with_back;
		state.params.cB_addStorage_check_left = params.cB_addStorage_check_both_with_back;

		state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		state.isFullyEnclosedChecked = false;
		params.p_b_w = "Open";

		params.cB_addStorage_check_both = false;
		params.nostorage = false;

		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;

		params.cB_addStorage_right = Math.round(params.p_w / 2 - 2.5);
		params.cB_addStorage_left = Math.round(params.p_w / 2 - 2.5);
		cuBuilding.BuildingUpdate(false, "utilitywall");

		cuBuilding.BuildingUpdate(false, "utilitywallRight");
		cuBuilding.BuildingUpdate(false, "utilitywallLeft");

		if (params.p_l_w != "Close") {
		} else {
		}
		if (params.p_r_w != "Close") {
		} else {
		}
		if (params.p_l_w != "Close") {
			if (params.p_r_w != "Close") {
			}
		} else if (params.p_b_w != "Close") {
		} else if (params.p_l_w != "Close" && params.p_b_w != "Close") {
		} else {
		}
		UpdateStorageAction = action.event + action.storage + params.cB_addStorage_check_right + params.cB_addStorage_check_left + params.p_u_c;
	}

	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.insulation_price_changed = true;
	if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
	const_var.wallSelection.centerBuildingWall = "c_b_f_w";
	const_var.wallSelection.leanToWall = "select";
	params.activeWall = "c_b_f_w";
	cuComponent.cameraFocusOnWall("c_b_f_w");
	return {
		...state,
		newColor: UpdateStorageAction
	};
};
export const noBuildingUtility = (state, action) => {
	params.nostorage = !params.nostorage;
	if (params.nostorage == true) {
		if (state.isFullyEnclosedChecked == true) {
			params.p_b_w = params.p_l_w = params.p_r_w = "Close";
			params.p_u_c = false;
			params.cB_addStorage_check_right = false;
			params.cB_addStorage_check_left = false;
			params.cB_addStorage_check_both = false;
			params.cB_addStorage_check_both_with_back = false;
		} else {
			if (params.p_u_c == true) {
				if (params.endStoragePositionZ === 0) params.p_b_w = "Open";
				else if (params.endStoragePositionZ === params.p_d - params.p_u_t) params.p_f_w = "Open";
				params.p_u_c = false;
			}
			if (params.cB_addStorage_check_front == true) {
				params.p_f_w = "Open";
				params.cB_addStorage_check_front = false;
			}
			if (params.cB_addStorage_check_left == true) {
				params.p_l_w = "Open";
				params.cB_addStorage_check_left = false;
			}
			if (params.cB_addStorage_check_right == true) {
				params.p_r_w = "Open";
				params.cB_addStorage_check_right = false;
			}
			params.cB_addStorage_check_both = false;
			params.cB_addStorage_check_both_with_back = false;
		}
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		const_var.UpdatedPriceData.insulation_price = undefined;
		if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
		params.noStorageCertificatePriceChange = true;
		const compRemoveWalls = ["c_b_r_s_f_w", "c_b_r_s_b_w", "c_b_r_s_l_w", "c_b_l_s_f_w", "c_b_l_s_b_w", "c_b_l_s_r_w", "c_b_f_s_w", "c_b_l_s_w", "c_b_r_s_w"];
		if (params.p_b_w != "Close") compRemoveWalls.push("c_b_b_w");
		if (params.p_l_w != "Close") compRemoveWalls.push("c_b_l_w");
		if (params.p_r_w != "Close") compRemoveWalls.push("c_b_r_w");
		params.prev_p_b_w = params.p_b_w;
		if (parseInt(params.endStoragePositionZ) + parseInt(params.p_u_t) == parseInt(params.p_d)) {
			params.prev_p_f_w = params.p_f_w = "Open";
		}
		// utils.checkForExtraAddOnCheckedoption();
		cuBuilding.cP();
	}
	cuBuilding.BuildingUpdate(false, "utilitywallRight");

	return {
		...state,
		action
	};
};
export const utilityChangeByLength = (state, action) => {
	let checkUtilityVal = action.str + action.value + new Date();
	const_var.isUtilityChanges = true;
	const_var.isUtilityLengthChange = true;
	utils.update26GAUpgradePrice();
	utilityStorageOptionsHelpers.applyUtilityLengthChange(action.str, action.value, state);
	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.wallSelection.centerBuildingWall = "c_b_f_w";
	const_var.wallSelection.leanToWall = "select";
	params.activeWall = "c_b_f_w";
	cuComponent.cameraFocusOnWall("c_b_f_w");
	return {
		...state,
		newColor: checkUtilityVal
	};
};
export const addFrontUtility = (state, action) => {
	utils.update26GAUpgradePrice("front");
	let frontLengthChange = action.isLengthChange ? action.isLengthChange : false;
	let renderDataF = utilityStorageOptionsHelpers.toggleLeanToStorage(state, "front", frontLengthChange);
	const_var.isUtilityChanges = true;
	return {
		...state,
		newColor: renderDataF
	};
};
export const addBackUtility = (state, action) => {
	utils.update26GAUpgradePrice("back");
	let backLengthChange = action.isLengthChange ? action.isLengthChange : false;
	let renderDataB = utilityStorageOptionsHelpers.toggleLeanToStorage(state, "back", backLengthChange);
	const_var.isUtilityChanges = true;
	return {
		...state,
		newColor: renderDataB
	};
};
export const addLeftUtility = (state, action) => {
	utils.update26GAUpgradePrice("left");
	let lengthChange = action.isLengthChange ? action.isLengthChange : false;
	let renderData = utilityStorageOptionsHelpers.toggleLeanToStorage(state, "left", lengthChange);
	const_var.isUtilityChanges = true;
	return {
		...state,
		newColor: renderData
	};
};
export const addRightUtility = (state, action) => {
	utils.update26GAUpgradePrice("right");
	let rightLengthChange = action.isLengthChange ? action.isLengthChange : false;
	let renderData1 = utilityStorageOptionsHelpers.toggleLeanToStorage(state, "right", rightLengthChange);
	const_var.isUtilityChanges = true;
	return {
		...state,
		newColor: renderData1
	};
};
export const toggleActionForUtility = (state, action) => {
	if (action.value == "left") {
		state.params.leftstorage = !state.params.leftstorage;
		if (state.params.leftstorage == true) {
			state.params.wallPos = "LeftS";
		} else {
			state.params.wallPos = "FrontL";
		}
		if (state.params.rightstorage == true) {
			state.params.rightstorage = false;
			state.params.wallPos = "FrontR";
		}
	}
	if (action.value == "right") {
		state.params.rightstorage = !state.params.rightstorage;
		if (state.params.rightstorage == true) {
			state.params.wallPos = "RightS";
		} else {
			state.params.wallPos = "FrontR";
		}
		if (state.params.leftstorage == true) {
			state.params.leftstorage = false;
			state.params.wallPos = "FrontL";
		}
	}
	if (action.value == "center") {
		state.params.centerstorage = !state.params.centerstorage;
	}
	return {
		...state,
		newColor: action.value + state.params.leftstorage + state.params.rightstorage + state.params.centerstorage
	};
};
